export enum Icons {
  email = "email",
  mobilePhone = "phone",
  landlinePhone = "phone-alt",
  fax = "fax",
  location = "location",
  website = "website",
  building = "building",
  profession = "work",
  addContact = "contact",
  clock = "clock",
  users = "users",
  calendar = "calendar",
  circleStar = "circle-star",
  external = "external",
  crown = "crown",
  userCircle = "user-circle",
}
